import { render } from "./BasicLayout.vue?vue&type=template&id=786a3f91&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"

import "./BasicLayout.vue?vue&type=style&index=0&id=786a3f91&lang=less&scoped=true"
import "./BasicLayout.vue?vue&type=style&index=1&id=786a3f91&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786a3f91"]])

export default __exports__